import { NSALoginPage } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";

export default function LoginPage()
{
    return (
        <NSALoginPage
            product_id={ProductUUID.NAMIRASOFT_QUOTA}
        />
    )
}